export const expandedJurisTypes: Record<string, string[]> = {
  decisao: [
    'DECISAO',
    'DELIMITACAO_DE_DECISAO',
    'DECISAO_DA_PRESIDENCIA',
    'DECISAO_DA_VICE_PRESIDENCIA',
    'DECISAO_DA_CORREGEDORIA',
  ],
  acordao: [
    'ACORDAO',
    'ACORDAO_REPETITIVO',
    'REPERCUSSAO_GERAL',
    'ACORDAO_AFETACAO',
    'INCIDENTE_ASSUNCAO_COMPETENCIA',
  ],
  sumula: ['SUMULA'],
  orientacao_jurisprudencial: ['ORIENTACAO_JURISPRUDENCIAL'],
  sentenca: ['SENTENCA'],
  despacho: ['DESPACHO'],
}
